import React, { useRef } from 'react';
import LazyTable from 'app/component/lazy-table';
import { useNavigate } from 'react-router-dom';
import { useAppSelector } from 'app/config/store';
import { hasAnyAuthority } from 'app/shared/auth/private-route';
import { AUTHORITIES } from 'app/config/constants';
import { Checkbox } from 'primereact/checkbox';
import { boldNameFormatter } from 'app/shared/util/formatters';
import { FilterMatchMode } from 'primereact/api';

type LazyTableHandle = {
  getEncodedParams: () => any;
};

const AgentTable: React.FC = () => {
  const navigate = useNavigate();
  const account = useAppSelector(state => state.authentication.account);
  const isAdminOrAssistant = hasAnyAuthority(account.authorities, [AUTHORITIES.ADMIN, AUTHORITIES.ASSISTANT]);
  const tableRef = useRef<LazyTableHandle>(null);

  const onShowPerformance = (data: any) => {
    const tempParams = tableRef.current?.getEncodedParams();

    if (data.id) {
      navigate('/agents/performance/' + data.id + `?p=${tempParams}`);
    }
  };

  const careerFormatter = value => {
    if (value) {
      return value.positionNr + ' - ' + value.position;
    }
  };

  const onPhoneCall = phoneNr => {
    const telLink = `tel:${encodeURIComponent(phoneNr)}`;

    window.location.href = telLink;
  };

  const phoneFormatter = value => {
    if (value) {
      return (
        <span style={{ cursor: 'pointer' }} onClick={() => onPhoneCall(value)}>
          {value}
        </span>
      );
    }
  };

  const showToClientCheckbox = zaplatene => {
    return <Checkbox disabled={true} style={{ marginLeft: '1rem' }} checked={zaplatene as boolean} />;
  };

  return LazyTable({
    ref: tableRef,
    initialSortField: 'number',
    createUrl: '/create-agent',
    labelForCreateEntity: isAdminOrAssistant ? 'Vytvoriť poradcu' : null,
    serverUrl: '/api/agents/search',
    exportUrl: '/api/agents/export',
    globalFilterFields: ['number', 'name', 'firstName', 'lastName'],
    editActionAllowed: isAdminOrAssistant,
    infoActionAllowed: true,
    columns: [
      { field: 'activeAgent', header: 'Aktívny', formatter: showToClientCheckbox },
      { field: 'id', header: 'ID', filter: true, sortable: true },
      { field: 'number', header: 'Číslo', filter: true, sortable: true },
      { field: 'nameFullFormatted', header: 'Meno poradcu', filter: true, sortable: false, formatter: e => boldNameFormatter(e) },
      { field: 'newCareer', header: 'Nová kariéra', filter: true, formatter: careerFormatter },
      { field: 'oldCareer', header: 'Stará kariéra', filter: true, formatter: careerFormatter },
      { field: 'phone', header: 'Telefón', filter: true, sortable: true, formatter: phoneFormatter },
      { field: 'ico', header: 'IČO', filter: true, sortable: true },
      { field: 'birthNr', header: 'Rodné číslo', filter: true, sortable: true },
    ],
    filters: {
      id: { value: null, matchMode: FilterMatchMode.EQUALS },
      number: { value: null, matchMode: FilterMatchMode.CONTAINS },
      nameFullFormatted: { value: null, matchMode: FilterMatchMode.CONTAINS },
      newCareer: { value: null, matchMode: FilterMatchMode.CONTAINS },
      oldCareer: { value: null, matchMode: FilterMatchMode.CONTAINS },
      phone: { value: null, matchMode: FilterMatchMode.CONTAINS },
      ico: { value: null, matchMode: FilterMatchMode.CONTAINS },
      birthNr: { value: null, matchMode: FilterMatchMode.CONTAINS },
    },
    additionalActions: [
      {
        icon: 'pi pi-chart-line',
        tooltip: 'Výkon',
        onClick: onShowPerformance,
      },
    ],
  });
};

export default AgentTable;
